import history from '../../util/history'

const toDetailView = id => {
  history.push(`/segment_settings/${id}/detail`)

  return true
}

export default toDetailView
